module.exports = __webpack_public_path__ + "static/media/notificationPurple.9bdfa098.png";